import { render, staticRenderFns } from "./PlayerCardParts.vue?vue&type=template&id=04c9fc04&scoped=true"
import script from "./PlayerCardParts.vue?vue&type=script&lang=ts"
export * from "./PlayerCardParts.vue?vue&type=script&lang=ts"
import style0 from "./PlayerCardParts.vue?vue&type=style&index=0&id=04c9fc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9fc04",
  null
  
)

export default component.exports